import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ServiceState {
  selectedServiceId: string | null;
  setSelectedServiceId: (id: string | null) => void;
}

/**
 * Currently selected service (tenant) for the admin console.
 * null = own service (the API falls back server-side when the header is absent).
 */
export const useServiceStore = create<ServiceState>()(
  persist(
    (set) => ({
      selectedServiceId: null,
      setSelectedServiceId: (id) => set({ selectedServiceId: id }),
    }),
    { name: "meshcore-admin-service" }
  )
);

/** Non-reactive read for the axios interceptor. */
export function getSelectedServiceId(): string | null {
  return useServiceStore.getState().selectedServiceId;
}

/** Clear the selected service (used on logout so a new account starts clean). */
export function clearSelectedService(): void {
  useServiceStore.getState().setSelectedServiceId(null);
}
